define(
  'MonsterThemeHelpers.EntryPoint', [
    'Utils',
    'jQuery',
    'underscore',
    'Header.Menu.View'
  ],
  function (
    Utils,
    jQuery,
    _,
    HeaderMenuView
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var self = this;
        var layout = container.getComponent('Layout');
        var environment = container.getComponent('Environment');
        var config = environment.getConfig('monsterThemeHelpers');
        var pdp = container.getComponent('PDP');
        var plp = container.getComponent('PLP');
        var title = Utils.translate('Resistance Test Results:');
        var subtitle = Utils.translate("Manufacturer's Fuse mΩ Values");
        var userProfile = container.getComponent('UserProfile');
        var checkout = container.getComponent('Checkout');
        var myAccountMenu = container.getComponent('MyAccountMenu');
        var published = SC.published || SC.ENVIRONMENT.published;
        self.categories = SC.CONFIGURATION.navigationData;
        self.restrictedRoleId = environment.getConfig('monsterThemeHelpers.restrictedRoleId');
        self.currentRole = published && published.currentUserRole && published.currentUserRole.role;

        if (layout) {

          layout.addToViewEventsDefinition(
            'ProductDetails.Information.View',
            'click [data-action="toggle-collapse"]',
            function (event) {
              var clickedTitle = event.currentTarget;
              var index = clickedTitle.getAttribute('data-index');
              var targetPanel = jQuery('#product-details-information-tab-content-container-' + index);
              var targetTitle = jQuery('#product-details-collapsible-accordion-' + index);
              var isOpen = targetPanel.hasClass('open');

              targetPanel.removeClass('open');
              targetTitle.removeClass('open');

              if (!isOpen) {
                targetPanel.addClass('open');
                targetTitle.addClass('open');
              }
            }
          );

          if (pdp) {
            layout.addToViewContextDefinition('ProductDetails.QuickView.View', 'resistanceTestResults', 'object', function (context) {
              var item = context && context.model && context.model.item;
              var low = item && item.custitem_uc_low_resistance_test_result ? item.custitem_uc_low_resistance_test_result.toString() : '';
              var high = item && item.custitem_uc_hig_resistance_test_result ? item.custitem_uc_hig_resistance_test_result.toString() : '';
              var average = item && item.custitem_uc_ave_resistance_test_result ? item.custitem_uc_ave_resistance_test_result.toString() : '';
              var resistanceTestResults = {};

              if (item.itemtype === 'InvtPart') {
                resistanceTestResults = {
                  showData: Boolean(low) || Boolean(high) || Boolean(average),
                  title: title,
                  subTitle: subtitle,
                  low: low,
                  high: high,
                  average: average
                };
              }

              return resistanceTestResults;
            });

            layout.addToViewContextDefinition('ProductDetails.Information.View', 'details', 'array', function (context) {
              var iteminfo = pdp.getItemInfo();
              var item = iteminfo && iteminfo.item;
              var average = item && item.custitem_uc_ave_resistance_test_result || '';
              var high = item && item.custitem_uc_hig_resistance_test_result || '';
              var low = item && item.custitem_uc_low_resistance_test_result || '';
              var content = '';
              var details = context && context.details;

              if (average || high || low) {
                content = "<h3 class='quickview-resistance-results-sub-title'>" + subtitle + '</h3>';
                content += "<table class='resistance-test-results'>";

                if (low) {
                  content += '<tr><td>Low:</td><td>' + low + '</td></tr>';
                }

                if (high) {
                  content += '<tr><td>High:</td><td>' + high + '</td></tr>';
                }

                if (average) {
                  content += '<tr><td>Average:</td><td>' + average + '</td></tr>';
                }

                content += '</table>';
              }

              if (content) {
                details.push({
                  content: content,
                  itemprop: '',
                  name: title
                });
              }

              return details;
            });

            // Total in Stock for all locations on PDP
            layout.addToViewContextDefinition('ProductDetails.Full.View', 'allLocationsQuantity', 'string', function () {
              var iteminfo = pdp.getItemInfo();
              var allLocationsQuantity = iteminfo && iteminfo.item && iteminfo.item.quantityavailable_detail.quantityavailable;
              return allLocationsQuantity;
            });
          }

          // Total in Stock for all locations on PDP
          if (userProfile && plp || checkout || myAccountMenu) {
            userProfile.getUserProfile().then(function (profile) {
              var islogged;
              if (profile) {
                islogged = profile.isloggedin;
                if (islogged) {
                  if (plp) {
                    layout.addToViewContextDefinition('ProductLine.Stock.View', 'allLocationsQuantity', 'string', function (context) {
                      var plpItems = plp.getItemsInfo();
                      var internalid = context && context.model && context.model.internalid;

                      var matchedItem = _.find(plpItems, function (plpItem) {
                        return plpItem && plpItem.internalid === internalid;
                      });
                      return matchedItem ? matchedItem.quantityavailable : '';
                    });

                    // Add Total in Stock on Quick View
                    layout.addToViewContextDefinition('ProductDetails.QuickView.View', 'allLocationsQuantity', 'string', function (context) {
                      var allLocationsQuantity = context && context.model && context.model.item && context.model.item.quantityavailable;
                      return allLocationsQuantity;
                    });
                  }
                }

                layout.addToViewContextDefinition('Header.MiniCart.View', 'showMiniCart', 'boolean', function () {
                  var showIconCart = true;
                  return self.isRestrictedRole(showIconCart, self, islogged);
                });

                if (plp) {
                  layout.addToViewContextDefinition('ProductViews.Price.View', 'isNotRestrictedRole', 'boolean', function () {
                    var showPrice = true;
                    return self.isRestrictedRole(showPrice, self, islogged);
                  });

                  layout.addToViewContextDefinition('ProductViews.Price.View', 'isLoggedIn', 'boolean', function () {
                    return islogged;
                  });

                  layout.addToViewContextDefinition('Cart.AddToCart.Button.View', 'isCurrentItemPurchasable', 'boolean', function (context) {
                    var showPlpAddToCart = true;
                    if (pdp && pdp.getItemInfo() && pdp.getItemInfo().item) {
                      return self.isRestrictedRole(showPlpAddToCart, self, islogged) && context.isCurrentItemPurchasable;
                    }
                    return self.isRestrictedRole(showPlpAddToCart, self, islogged);
                  });
                }

              }
            });
          }

          layout.on('afterShowContent', function () {
            var currentUrl = window.location.href;
            var isLocal = currentUrl.indexOf('local') >= 0;
            var urlFragment = isLocal ? window.location.hash : window.location.pathname;
            var isSpecialPage = Boolean(_.some(config.pages || [], function (page) {
              var url = isLocal ? page.replace('/', '#') : page;
              return urlFragment === url;
            }));
            var isHomepage = Utils.isShoppingDomain() && (!urlFragment || urlFragment === '/');

            if (jQuery('.product-details-information-tab-content-panel-title').length > 0) {
              jQuery('.product-details-information-tab-content-panel-title').addClass('open');
              jQuery('.product-details-information-tab-content-container').addClass('open');
              jQuery('.bottom-panel .collapsible').addClass('open');
            }

            self.modifyClass('full-background', isSpecialPage || isHomepage);
            jQuery('[data-facet-id="custitem_manufacturer"]').css('display', 'none');
          });
        }

        _.extend(HeaderMenuView.prototype, {
          events: _.extend(HeaderMenuView.prototype.events, {
            'mouseenter [data-toggle="categories-menu"]': 'menuOpen',
            'mouseleave [data-toggle="categories-menu"]': 'menuClose',
            'click [data-toggle="categories-menu"]': 'menuClose',
            'mouseenter [data-toggle="sub-categories-menu"]': 'subMenuOpen',
            'mouseleave [data-toggle="sub-sub-categories-menu"]': 'subMenuClose'
          }),

          menuOpen: function (e) {
            var left;
            self.menuOpened = self.menuOpened ? self.menuOpened : e && e.target.childNodes.length > 0 && e.target.childNodes[0].textContent;
            left = e.currentTarget && e.currentTarget.offsetLeft;
            if (e.currentTarget && e.currentTarget.className === '') {
              jQuery('#categories-' + self.capitalizeFirstLetter(self.menuOpened)).css('left', left);
            }
            jQuery(e.currentTarget).addClass('open');
          },

          menuClose: function (e) {
            jQuery(e.currentTarget).removeClass('open');
            this.subMenuClose();
            self.menuOpened = '';
          },

          subMenuOpen: function (e) {
            var subCategories = self.getCategories(self.menuOpened);
            var currentCategorie = e.currentTarget && e.currentTarget.innerText;
            var currentCategoryUrl = jQuery(e.currentTarget).attr('href');
            var curerntSubCategories = self.getSubCategories(currentCategorie, subCategories, config, currentCategoryUrl);
            var target = jQuery('#sub-categories-' + self.capitalizeFirstLetter(self.menuOpened))[0];
            var i, currentItem, listItem, anchorElement, spanElement, widthMenuFuses, categoryFusesLeft, widthMenuControls, categoryControlsLeft;
            if (target && target.children.length > 0) {
              jQuery('#sub-categories-' + self.capitalizeFirstLetter(self.menuOpened)).empty();
              jQuery('#sub-categories-' + self.capitalizeFirstLetter(self.menuOpened)).removeClass('show-subcategorie');
            }

            if (curerntSubCategories.length > 0) {
              for (i = 0; i < curerntSubCategories.length; i++) {
                currentItem = curerntSubCategories[i];
                listItem = jQuery('<li></li>');
                anchorElement = jQuery('<a></a>');

                anchorElement.addClass(currentItem.class);
                /* anchorElement.attr('data-toggle', 'sub-sub-categories-menu'); */
                anchorElement.attr('data-touchpoint', 'home');
                anchorElement.attr('data-hashtag', currentItem.data && currentItem.data.hashtag || '');
                anchorElement.attr('href', currentItem.href);

                spanElement = jQuery('<span></span>').text(currentItem.text);

                anchorElement.append(spanElement);

                listItem.append(anchorElement);
                jQuery('#sub-categories-' + self.capitalizeFirstLetter(self.menuOpened)).append(listItem);
                jQuery('#sub-categories-' + self.capitalizeFirstLetter(self.menuOpened)).attr('data-toggle', 'sub-sub-categories-menu');
              }
              jQuery('#sub-categories-' + self.menuOpened).addClass('show-subcategorie');

              widthMenuFuses = jQuery('#categories-Fuses .header-menu-level2').width();
              categoryFusesLeft = jQuery('#categories-Fuses').css('left') && jQuery('#categories-Fuses').css('left').replace('px', '');
              jQuery('#sub-categories-Fuses').css('left', widthMenuFuses + parseInt(categoryFusesLeft) + 'px');

              widthMenuControls = jQuery('#categories-Controls .header-menu-level2').width();
              categoryControlsLeft = jQuery('#categories-Controls').css('left') && jQuery('#categories-Controls').css('left').replace('px', '');
              jQuery('#sub-categories-Controls').css('left', widthMenuControls + parseInt(categoryControlsLeft) + 'px');
            }
          },

          subMenuClose: function () {
            jQuery('#sub-categories-' + self.capitalizeFirstLetter(self.menuOpened)).empty();
            jQuery('#sub-categories-' + self.capitalizeFirstLetter(self.menuOpened)).removeClass('show-subcategorie');
          }
        });
      },

      isRestrictedRole: function isRestrictedRole(showParam, self, islogged) {
        var show = showParam;
        if (self.restrictedRoleId && self.currentRole === self.restrictedRoleId || !islogged) {
          show = false;
        }

        return show;
      },

      getCategories: function getCategories(menuOpened) {
        var categories, generalCat, position, i;
        if (this.categories) {
          categories = [];
          generalCat = this.categories;
          for (i = 0; i < generalCat.length; i++) {
            position = generalCat[i];
            if (position.text && position.text.toUpperCase() === menuOpened.toUpperCase() && position.categories && position.categories.length > 0) {
              categories = _.union(categories, generalCat[i].categories);
            }
          }
          return categories;
        }
      },

      getSubCategories: function getSubCategories(currentCategory, subCategories, config, currentCategoryUrl) {
        var isCategory = false;
        var currentSubCategories = [];
        var i = 0;
        var maximumSubCategories = config && Number(config.subcategoriesMax) || 6;

        while (!isCategory && i <= subCategories.length) {
          if (subCategories[i] && subCategories[i].text && subCategories[i].text.toUpperCase() === currentCategory.toUpperCase()) {
            isCategory = true;
            currentSubCategories = subCategories[i].categories;
          }
          i++;
        }
        if (currentSubCategories.length > maximumSubCategories) {

          currentSubCategories = currentSubCategories.slice(0, maximumSubCategories);
          currentSubCategories.push({
            text: config.subcategoriesSeeMoreText || Utils.translate('See more...'),
            href: currentCategoryUrl,
            class: 'header-menu-level3-anchor',
            'data-type': 'commercecategory',
            data: {
              hashtag: '#' + currentCategoryUrl,
              touchpoint: 'home'
            }
          });
        }

        return currentSubCategories;
      },

      capitalizeFirstLetter: function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      },

      modifyClass: function modifyClass(className, setClass) {
        var element = jQuery('#main-container');
        if (setClass) {
          element.addClass(className);
        } else {
          element.removeClass(className);
        }
      }
    };
  });
